<template>
  <el-collapse-item name="2">
    <template slot="title">
      PLP Externa&nbsp;<el-tag>{{ tableData.length }}</el-tag>
    </template>
    <el-table :data="tableData" size="small" stripe>
      <el-table-column sortable prop="plp" :label="$t('plp')" />
      <el-table-column sortable prop="tag" :label="$t('etiqueta')" />
      <el-table-column width="80" align="right">
        <template slot-scope="scope">
          <el-button type="danger" size="small" icon="el-icon-delete" @click="remove(scope.row.tag)" circle></el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-collapse-item>
</template>

<script>

export default {
  name: "PdvClosedExternal",
  data() {
    return {
      tableData: [],
    }
  },
  methods: {
    clear() {
      this.tableData = [];
    },
    add(data) {
      this.tableData.push(data);
    },
  },
}
</script>